import React from "react";
import { observer } from "mobx-react";
import { TenantStatusViewStore } from "../../store";
import { TenantStatusViewForm } from "./TenantStatusViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type TenantStatusViewProps = {
  tenantStatusViewStore: TenantStatusViewStore;
};

export const TenantStatusView: React.FC<TenantStatusViewProps> = observer(
  ({ tenantStatusViewStore }) => {
    return (
      <div>
        <TenantStatusViewForm
          name={tenantStatusViewStore.nameValue}
          description_es={tenantStatusViewStore.description_esValue}
          description_en={tenantStatusViewStore.description_enValue}
          description_pt={tenantStatusViewStore.description_ptValue}
          blocksAccess={tenantStatusViewStore.blocksAccessValue}
          onPrint={(handlePrint: () => void) =>
            tenantStatusViewStore.printTenantStatus(handlePrint)
          }
          onCancel={() => tenantStatusViewStore.cancelTenantStatus()}
          onEdit={
            tenantStatusViewStore.isEditEnabled
              ? () => tenantStatusViewStore.editTenantStatus()
              : undefined
          }
        />
        <ErrorDialog
          open={tenantStatusViewStore.errorDialogOpened}
          title={tenantStatusViewStore.errorTitle}
          description={tenantStatusViewStore.errorDescription}
          onClose={() => tenantStatusViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
